import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';

@Component({
  selector: 'connect-virtualization-detail',
  templateUrl: 'connect-virtualization-detail.component.html',
  styleUrls: ['connect-virtualization-detail.component.scss']
})
export class ConnectVirtualizationDetailComponent implements OnInit, OnChanges {

  public virtualEntities: Array<TreeItem> = [];
  @Input() guidProvider: string;

  constructor(private _connectProviderService: ConnectProviderService) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.guidProvider) {
      this._connectProviderService.getVirtualEntities(this.guidProvider).subscribe((data) => {
        this.virtualEntities = data;
      });
    }
  }

}
